export const fileUploadTypes = {
  ICON: 'icon',
  SIZE: 'size'
};

export const embedUrlRegex =
  /^(https?:\/\/)?(www\.)?youtube\.com\/embed\/[A-Za-z0-9_-]{11}/;
export const youtubeRegex =
  /^(https?:\/\/)?(www\.)?(youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]+)(.{0,500})$/;

export const defaultValues = {
  appName: 'Sample Local App',
  shortDescription:
    'This is a sample local development app that can be used for testing and development purposes.',
  appOverView:
    'Please use the MCP configuration to enable our AI assisted coding',
  appInstructions:
    'Please connect your local app to an Ngrok or similar proxy service to allow us to access your local app.',
  videoUrl: '',
  supportEmail: 'support@domain.ai',
  supportUrl: '',
  websiteLink: '',
  icon: {},
  ngrokUrl: '',
  location: 'full_page_app',
  events: [] as string[],
  iParams: {} as Record<string, any>,
  oauth: {} as any,
  whitelistedDomains: [] as string[]
};

export const appTypeConstants = {
  CUSTOM: 'CUSTOM',
  DRAFT: 'DRAFT',
  PUBLIC: 'PUBLIC',
  DEAL: 'DEAL',
  PRIVATE: 'PRIVATE',
  PUBLISHED: 'PUBLISHED'
};
